document.addEventListener('DOMContentLoaded', function() {
  // Find the collection description container (updated for your theme)
  const collectionDesc = document.querySelector('.hero__rte');
  
  if (collectionDesc) {
    let html = collectionDesc.innerHTML;
    
    // Check if FAQ markers exist
    if (html.includes('<!-- FAQ_START -->') && html.includes('<!-- FAQ_END -->')) {
      // Extract FAQ content
      const faqStart = html.indexOf('<!-- FAQ_START -->');
      const faqEnd = html.indexOf('<!-- FAQ_END -->') + '<!-- FAQ_END -->'.length;
      const beforeFAQ = html.substring(0, faqStart);
      const faqContent = html.substring(faqStart, faqEnd);
      const afterFAQ = html.substring(faqEnd);
      
      // Create new HTML with button and wrapper
      collectionDesc.innerHTML = beforeFAQ + 
      '<div class="faq-toggle-wrapper"><button class="faq-toggle-btn" id="faqToggleBtn">See More  </button></div>' +
      '<div class="faq-wrapper" id="faqWrapper">' + faqContent + '</div>' +
      afterFAQ;
      
      // Add click event to button
      const toggleBtn = document.getElementById('faqToggleBtn');
      const wrapper = document.getElementById('faqWrapper');
      
      if (toggleBtn && wrapper) {
        toggleBtn.addEventListener('click', function() {
          wrapper.classList.toggle('show');
          toggleBtn.classList.toggle('active');
          
          if (wrapper.classList.contains('show')) {
            toggleBtn.innerHTML = 'See Less  ';
          } else {
            toggleBtn.innerHTML = 'See More  ';
          }
        });
      }
    }
    if (html.includes('<p>&lt;!--FAQ_START--&gt;</p>') && html.includes('<p>&lt;!--FAQ_END--&gt;</p>')) {
      // Extract FAQ content
      const faqStart = html.indexOf('<p>&lt;!--FAQ_START--&gt;</p>');
      const faqEnd = html.indexOf('<p>&lt;!--FAQ_END--&gt;</p>') + '<p>&lt;!--FAQ_END--&gt;</p>'.length;
      const beforeFAQ = html.substring(0, faqStart);
      const faqContent = html.substring(faqStart, faqEnd);
      const afterFAQ = html.substring(faqEnd);
      
      // Create new HTML with button and wrapper
      collectionDesc.innerHTML = beforeFAQ + 
      '<div class="faq-toggle-wrapper"><button class="faq-toggle-btn" id="faqToggleBtn">See More  </button></div>' + '<div class="faq-wrapper" id="faqWrapper">' + faqContent + '</div>' + afterFAQ;
      
      // Add click event to button
      const toggleBtn = document.getElementById('faqToggleBtn');
      const wrapper = document.getElementById('faqWrapper');
      
      if (toggleBtn && wrapper) {
        console.log('exist');
        toggleBtn.addEventListener('click', function() {
          console.log('test');
          
      wrapper.innerHTML = wrapper.innerHTML.replace('<p>&lt;!--FAQ_START--&gt;</p>', '').replace('<p>&lt;!--FAQ_END--&gt;</p>', '');
          wrapper.classList.toggle('show');
          toggleBtn.classList.toggle('active');
          
          if (wrapper.classList.contains('show')) {
            toggleBtn.innerHTML = 'See Less  ';
          } else {
            toggleBtn.innerHTML = 'See More  ';
          }
        });
      }

      
      
    }

  }
});